'use strict';

module.exports = Error.captureStackTrace || function (error) {
	var container = new Error();

	Object.defineProperty(error, 'stack', {
		configurable: true,
		get: function getStack() {
			var stack = container.stack;

			Object.defineProperty(this, 'stack', {
				value: stack
			});

			return stack;
		}
	});
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/capture-stack-trace/index.js
// module id = KvQF
// module chunks = 0